import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, CircularProgress, Autocomplete, TextField, MenuItem } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './settings.css'
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import UserSettingsHeader from '../../components/HeadersNav/userSettingsHeader';
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

const PersonalPayrollReport = () => {
  const { user, permission, v3Data } = useContext(AuthContext)
  const [loading, setLoading] = useState(false);
  const [loadingGrid, setLoadingGrid] = useState(false);
  const [payrollData, setPayrollData] = useState([]);
  const [payrollList, setPayrollList] = useState([]);
  const timeFormat = (timeStr) => timeStr?.slice(0, 5);
  const [errorMsg, setErrorMsg] = useState('');
  const [payrollEndDate, setPayrollEndDate] = useState("");
  const [acknowledge, setAcknowledge] = useState(false);
  const [activeTab, setActiveTab] = useState('acknowledge-payroll');
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([])
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [payCode, setPayCode] = useState("");
  const [shiftDate, setShiftDate] = useState("");
  const [shifCode, setShiftCode] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [ptoShifts, setPtoShifts] = useState([]);
  const [periodDrop, setPeriodDrop] = useState([]);
  const [period, setPeriod] = useState();


  const toSentenceCase = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  const columns = [
    {
      field: 'Shift_Date', headerName: 'Shift Date', flex: 1, minWidth: 150,
      valueGetter: (params) => { return moment(params?.row?.shift_date).format('dddd MMMM Do YYYY') }
    },

    // {
    // 	field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 130,
    // 	renderCell: (params) => {
    // 		return (
    // 			<Chip sx={{ width: '120px !important' }}
    // 				label={params?.row?.shift_name}
    // 				className={params?.row?.shift_name == "Day" ? 'day-chip' : 'night-chip'} />)
    // 	}
    // },
    {
      field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 130, headerAlign: 'center', align: 'center',
      renderCell: (params) => {
        const shiftType = params?.row?.shift_type; // payrollList?.shift_type

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Chip

              label={params?.row?.shift_name}
              className={
                params?.row?.shift_name === "Day"
                  ? 'day-chip-settings'
                  : 'night-chip-settings'
              }
            />

            {shiftType && (
              <Chip label={toSentenceCase(shiftType)} />
            )}
          </Box>
        );
      },
    },


    {
      field: 'Hours', headerName: 'Hours', flex: 1, minWidth: 160, headerAlign: 'center', align: 'center',
      renderCell: (params) => {
        const row = params?.row;
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Hours text */}
            <span>
              {row?.hours_worked} (
              {varFormatTime(timeFormat(row?.start_time), user?.Time_Format)} -{" "}
              {varFormatTime(timeFormat(row?.end_time), user?.Time_Format)})
            </span>
            {row?.is_overtime_custom && (
              <Chip
                label="Custom"
                sx={{
                  backgroundColor: "#FFE0B2",
                  width: '85px',
                }}
              />
            )}
          </Box>
        )
        // `${params?.row?.hours_worked} (${varFormatTime(timeFormat(params?.row?.start_time), user?.Time_Format)} - ${varFormatTime(timeFormat(params?.row?.end_time), user?.Time_Format)})`
      }
    },

    {
      field: 'Pay', headerName: 'Pay', flex: 1, minWidth: 160, headerAlign: 'center', align: 'center', valueGetter: (params) => {
        const pay = params?.row?.shift_pay;
        return pay === 'N/A' ? 'N/A' : `$ ${pay}`;
      }
    },
    {
      field: 'Paycode',
      headerName: 'Pay Code',
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        const payCode = params?.row?.pay_code;

        // default = Pay
        const label = payCode === "COMP_PAY" ? "Comp Pay" : "Pay";

        return (
          <Chip
            label={label}
            sx={{
              minWidth: "90px !importent"
            }}
          />
        );
      },
    },
    {
      field: 'Action',
      headerName: 'Action',
      flex: 1,
      minWidth: 160,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const row = params.row;

        if (row?.shift_type !== 'overtime') return null;
        const isDisabled = Boolean(payrollData?.is_payroll_acknowledged);

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Button */}
            {row?.shift_details?.is_overtime_payroll && <ButtonTheme
              size="small"
              color="primary"
              disabled={row?.pay_code === "COMP_PAY" || payrollData?.is_payroll_acknowledged}
              onClick={() => handleMakeCompPay(row, "comp_pay")}
            >
              Make It Comp Pay
            </ButtonTheme>}

            {/* Revert Icon */}
            {row?.pay_code === "COMP_PAY" && (
              <img
                src="/images/revert-new.png"
                width={22}
                height={22}
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.4 : 1,
                  pointerEvents: isDisabled ? 'none' : 'auto',
                }}
                onClick={() => handleMakeCompPay(row, "pay")}
              />

            )}
          </Box>
        );
      },
    },
    {
      field: 'Status', headerName: 'Status', flex: 1, minWidth: 160, headerAlign: 'center', align: 'center',
      renderCell: (params) => {
        const status = params?.row?.is_acknowledgeable;
        return (
          <Chip sx={{ width: '120px !important' }}
            label={status ? 'Approved' : 'Unapproved'}
            className={status ? 'approved-chip' : 'unapproved-chip'} />)
      }
    }
  ]

  const loadMonthsList = () => {
    ApiService.get('/payroll/pay-acknowledgement-month-ddl')
      .then(({ data }) => {
        var assignMonth = data?.map((assign) => { return { label: assign.label, value: assign.value } })
        setPeriodDrop(assignMonth)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const loadEmployees = () => {
    ApiService.get('/employees-list?search=')
      .then(({ data }) => {
        var tempArr = []
        data.data.map((emp) => {
          var obj = emp
          obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
          tempArr.push(obj)
        })
        setEmployees(tempArr)
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const getPayrollList = (loader = true, gridLoader = false) => {
    if (loader) {
      setLoading(true);
    }
    if (gridLoader) {
      setLoadingGrid(true);
    }
    const body = {
      Emp_Code: selectedEmp?.Emp_Code || user?.Emp_Code,
      Month: period?.value
    }
    ApiService.post("/payroll/generate-report", body)
      .then(({ data }) => {
        setPayrollData(data)
        setPayrollEndDate(data?.payroll_acknowledge_end_date)
        setPayrollList(data?.shift_details);
        setLoading(false);
        setLoadingGrid(false);
      })
      .catch((e) => {
        setLoading(false);
        setErrorMsg(e?.response?.data?.message || 'No Payroll Period Found.Please check the variable value.')
      });
  };

  const getPtoShifts = (loader = true) => {
    if (loader) {
      setLoading(true);
    }
    const body = {
      Emp_Code: selectedEmp?.Emp_Code || user?.Emp_Code
    }
    ApiService.post("/payroll/user-pto-shift-detail", body)
      .then((response) => {
        setPtoShifts(response?.data)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setErrorMsg(e?.response?.data?.message || 'No Payroll Period Found.Please check the variable value.')
      });
  };

  // let year, month;
  // if (payrollData?.payroll_month) {
  // 	[year, month] = payrollData.payroll_month.split('-');
  // }

  const acceptPayroll = () => {
    setAcknowledge(true)
    let body = {
      "Emp_Code": selectedEmp?.Emp_Code,
      "period_end_date": payrollEndDate,
    }
    ApiService.post("/payroll/approval-report", body)
      .then((data) => {
        toast.success(data?.message)
        getPayrollList(false)
        setAcknowledge(false)
        setLoading(false);
      })
      .catch(({ data }) => {
        toast.error(data?.message)
        setAcknowledge(false)
        setLoading(false);
      });
  };

  useEffect(() => {
    getPayrollList()
    getPtoShifts()
    loadEmployees()
    loadMonthsList()
  }, [])

  useEffect(() => {
    getPayrollList()
    getPtoShifts()
  }, [selectedEmp])

  const handleSavePayCode = async () => {
    try {
      setLoading(true);

      const payload = {
        emp_code: selectedEmp?.Emp_Code,
        shift_date: shiftDate,
        status: "",
        shift_code: shifCode,
      };
      const res = await ApiService.post("/update-paycode", payload);
      if (res?.success) {
        toast.success(res?.message);
        setPayCode("");
        setShiftDate("");
        setShiftCode("");
        setOpenModal(false);
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleMakeCompPay = async (row, status) => {
    try {
      setLoading(true);

      const payload = {
        emp_code: selectedEmp?.Emp_Code ?? user?.Emp_Code,
        shift_date: row.shift_date,
        status: status,
        shift_code: row?.is_overtime_custom ? "91" : row.shift_code,
      };

      const res = await ApiService.post("/update-paycode", payload);
      if (res?.success) {
        toast.success(res?.message);
        getPayrollList(false);
      }
    } catch (error) {
      toast.error(error?.message || error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    getPayrollList(false, true);

  }, [period])

  return (
    <>
      {loading ? (
        <>
          <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam p-4" style={{ marginTop: "1rem" }}>
            <CircularProgress />
          </Paper>
        </>
      ) :
        (
          <>
            <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
              <Grid container spacing={2} className='align-items-center'>
                <Row
                  style={{
                    paddingLeft: '24px',
                    paddingTop: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Col xs="auto" style={{ padding: 0 }}>
                    <div
                      style={{ width: '190px' }}
                      className={activeTab === 'personal-payroll' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => {
                        setActiveTab('personal-payroll')
                        navigate('/firehouse/personal-payroll-list')
                      }}
                    >
                      Personal Payroll
                    </div>
                  </Col>

                  <Col xs="auto" style={{ padding: 0 }}>
                    <div
                      style={{ width: '210px' }}
                      className={activeTab === 'acknowledge-payroll' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => {
                        setActiveTab('acknowledge-payroll')
                        navigate('/firehouse/personal-payroll-report')
                      }}
                    >
                      Acknowledge Payroll
                    </div>
                  </Col>

                  {permission && permission.includes('Emp_Auth') && v3Data?.V3_CAN_ADMIN_OVERRIDE_TIMECARD_APPROVAL && (
                    <Col
                      xs="auto"
                      style={{
                        marginLeft: 'auto',
                        minWidth: '260px',
                      }}
                    >
                      <Autocomplete
                        options={employees}
                        value={selectedEmp}
                        getOptionLabel={(option) => option.label || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.Emp_Code === value?.Emp_Code
                        }
                        onChange={(event, newValue) => setSelectedEmp(newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Employee"
                            variant="outlined"
                            fullWidth
                            size="small"
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "48px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center"
                              }
                            }}
                          />
                        )}
                      />
                    </Col>
                  )}
                </Row>

                {/* Heading */}
                <Grid item xs={10} md={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                  <Typography variant="h5">Personal Payroll Report for ({payrollData?.period_start_date_formatted} - {payrollData?.period_end_date_formatted})</Typography>
                </Grid>

                <p className='px-3' style={{ marginTop: '0px', marginBottom: '0px', color: 'red' }}>You will be eligible to apply for Payroll Acknowledgment again on **{payrollData?.period_end_date_formatted}**</p>

                <Grid item xs={10} md={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", gap: "15px" }}>
                  <div style={{ display: 'flex', alignItems: 'left', flexDirection: 'column', width: '20%', }}>
                    <label>Period</label>
                    <Autocomplete
                      options={periodDrop}
                      onChange={(event, newValue) => setPeriod(newValue)}
                      value={period}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Period"
                          variant="outlined"
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "48px",
                              fontSize: "14px",
                              display: "flex",
                              alignItems: "center",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                  <div style={{ display: 'flex', gap: "15px", alignItems: 'center', justifyContent: 'center' }}>
                    <div><h5 style={{ marginBottom: '0px', marginTop: '6px' }}>Total Shifts- {payrollData?.total_shifts}</h5> <h6>(Acknowledgeable Shifts- {payrollData?.acknowledgeable_shifts})</h6></div>
                    <ButtonTheme style={{ height: '40px' }} onClick={acceptPayroll} disabled={(payrollData?.can_acknowledge == false) || (acknowledge == true)} color='primary'>{acknowledge ? 'Processing..' : 'Acknowledge All'}</ButtonTheme>
                  </div>
                </Grid>
              </Grid>
              {loadingGrid ? (
                <>
                  <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam p-4" style={{ marginTop: "1rem" }}>
                    <CircularProgress />
                  </Paper>
                </>
              ) :
                (!payrollList || payrollList.length == 0 ?
                  <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 400 }}>
                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                    <span className='mt-4' style={{ color: '#555555' }}>
                      {errorMsg}
                    </span>
                  </div>
                  :
                  <>
                    <div className='mt-4'>
                      <DataGrid
                        rows={payrollList}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooter={true}
                        sx={{
                          "& .MuiDataGrid-columnHeaderTitleContainer": {
                            display: "flex !important",
                          },
                          "& .MuiTablePagination-selectLabel": {
                            marginBottom: "0 !important"
                          },
                          "& .MuiTablePagination-displayedRows": {
                            marginBottom: "0 !important"
                          },
                          "& .MuiDataGrid-columnHeader": {
                            minWidth: "100px",
                          },
                        }}
                      />
                    </div>

                    <Grid container spacing={2} className='align-items-center'>
                      {/* Heading */}
                      <Grid item xs={10} md={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginTop: '40px' }}>
                        <Typography variant="h5">Custom Off Taken</Typography>
                      </Grid>
                    </Grid>

                    <div className='mt-4'>
                      <DataGrid
                        rows={ptoShifts}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooter={true}
                        sx={{
                          "& .MuiDataGrid-columnHeaderTitleContainer": {
                            display: "flex !important",
                          },
                          "& .MuiTablePagination-selectLabel": {
                            marginBottom: "0 !important"
                          },
                          "& .MuiTablePagination-displayedRows": {
                            marginBottom: "0 !important"
                          },
                          "& .MuiDataGrid-columnHeader": {
                            minWidth: "100px",
                          },
                        }}
                      />
                    </div>
                  </>
                )}
              <div>
                <h5 className='final-text'>Total Hours- {payrollData?.total_hours}</h5>
                {!v3Data?.V3_USE_TIMECARD_PERIOD &&
                  <h6>(Acknowledgeable Hours- {payrollData?.acknowledgeable_hours})</h6>
                }
                {v3Data?.V3_USE_TIMECARD_PERIOD &&
                  !(
                    payrollData?.total_pay === 'N/A' ||
                    payrollData?.total_pay === null ||
                    payrollData?.total_pay === '' ||
                    payrollData?.total_pay === 0
                  ) && (
                    <>
                      <h5>Grand Total - $ {payrollData?.total_pay}</h5>
                      <h6>(Acknowledgeable Pay - $ {payrollData?.acknowledgeable_pay})</h6>
                    </>
                  )}
              </div>
            </Paper>
          </>
        )
      }

    </>
  )
}
export default PersonalPayrollReport